import React from 'react';

function Header() {
  return (
    <header className="tc-inner-header-style1">
      <div className="container">
        <div className="info col-lg-8">
          <h2 className="js-title fsz-100"> Portfolio </h2>
          <div className="text fsz-18 color-666">
              <br />
            Architecture is a visual art, and our solutions speak for
            themselves
          </div>

        </div>
      </div>
    </header>
  );
}

export default Header;
